"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INITIAL_STATE = exports.INITIAL_STATE = {
  queue: [],
  isOnline: true
};